import { withPlaceholder } from '@sitecore-jss/sitecore-jss-react';
import { Carousel } from './Carousel';
export const SitecoreCarousel = withPlaceholder({
    placeholder: 'jss-carousel-slides',
    prop: 'slides',
})(Carousel);
